import { buildMock } from 'utils'

export default buildMock({
  id: 'ABC',
  level: 3,
  scope: 'scope',
})
